"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultApplicationRoutePathSet = void 0;
exports.defaultApplicationRoutePathSet = {
  changePassword: 'profile/change-password',
  login: 'login',
  home: '',
  homeReturn: 'home',
  logout: 'logout',
  network: 'network',
  following: 'following',
  connections: 'connections',
  wall: 'wall',
  conversations: 'conversations',
  profile: 'profile',
  taxonomies: 'taxonomies',
  setupTerms: 'setup/terms',
  setupChangePassword: 'setup/change-password',
  setupIntro: 'setup/intro',
  verifyChangePassword: 'verify-change-password/:id/:code'
};